import React from 'react';
import { CheckIcon, CreditCardIcon, FileTextIcon, LockIcon, ShieldCheckIcon, TargetIcon, UsersIcon, ZapIcon } from 'lucide-react';
import { heroStats, mockupUrl } from '../data/content';
import { Button } from './ui/Button';
const badges = [[FileTextIcon, '100% PDF'], [ZapIcon, 'Acceso en 5 min'], [TargetIcon, '0K → 5K → 10K → 21K'], [CheckIcon, 'Todos los niveles'], [UsersIcon, 'Corredores de todas las edades']] as const;
export function Hero() {
  return <section className="relative overflow-hidden px-4 pb-14 pt-9 md:pb-20 md:pt-14" data-id="element-177" data-mp="x9uqdm4c7y8b">
      <div className="pointer-events-none absolute left-1/2 top-[22%] h-[560px] w-[560px] -translate-x-1/2 rounded-full bg-accent/10 blur-[120px]" data-id="element-178" data-mp="sbb5lp1hcshj" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-179" data-mp="nbf0tnkykx0x">
        <div className="mb-5 inline-flex rounded-full border border-accent/30 bg-accent/10 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-wider text-accent-dark md:mb-6" data-id="element-180" data-mp="3d21sdxnwkknq">
          CompraDigitalYa™
        </div>
        <h1 className="mx-auto max-w-4xl text-[1.75rem] font-black uppercase leading-[1.05] tracking-tight text-ink md:text-[3.6rem]" data-id="element-181" data-mp="3j9kbdcsl9jgn">
          🏃 Combo Completo Running 2026
        </h1>

        <a href="#pricing" className="group my-6 flex justify-center rounded-3xl focus:outline-none md:my-8" aria-label="Ver el precio del Combo Completo Running 2026" data-id="element-182" data-mp="39b4l1c1dye87">
          <img className="w-full max-w-[860px] object-contain drop-shadow-[0_26px_44px_rgba(7,16,29,.32)] transition-transform duration-300 ease-out group-hover:scale-[1.015]" src={mockupUrl} alt="Mockup del Combo Completo Running 2026 con sus 6 tomos y 5 bonos" data-id="element-183" data-mp="30gzteqefgyrm" />
        </a>

        <p className="mx-auto max-w-4xl text-xl font-black leading-tight text-accent md:text-4xl" data-id="element-184" data-mp="2vj7u3bbgeade">
          Todo tu año de entrenamiento de carrera. Listo. Desde hoy.
        </p>

        <p className="mx-auto mt-5 max-w-2xl text-base font-semibold leading-relaxed text-slate-600 md:text-xl" data-id="element-185" data-mp="2ljgz78izdtcs">
          <strong className="text-ink" data-id="element-186" data-mp="s3mf683jc910">
            🇦🇷 EL SISTEMA COMPLETO PARA CORREDORES EN ARGENTINA.
          </strong>{' '}
          Entrenamientos de carrera + adaptaciones según cada distancia, de 0K a 21K. Listos para
          implementar, sin improvisar.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs font-semibold text-slate-600 md:text-sm" data-id="element-187" data-mp="degfkj0scgsl">
          {badges.map(([BadgeIcon, label]) => <span key={label} className="flex items-center gap-1.5" data-id="element-188" data-mp="161b0fh1ili6l">
              <BadgeIcon className="h-4 w-4 text-accent" data-id="element-189" data-mp="15zzr71pavi83" />
              {label}
            </span>)}
        </div>

        <div className="mt-8" data-id="element-190" data-mp="x1nwanhehy9u">
          <Button href="#pricing" className="w-full text-sm md:w-auto md:text-lg" data-id="element-191" data-mp="x0crqlg4smho">
            🏃 Quiero empezar hoy · ver precio de lanzamiento →
          </Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-slate-500 md:text-sm" data-id="element-192" data-mp="3hr3q7rbx233p">
          <span className="flex items-center gap-1" data-id="element-193" data-mp="1xavvwffu8055">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-accent" data-id="element-194" data-mp="21aekpmas4vd9" />
            Garantía 7 días
          </span>
          <span className="text-accent/40" data-id="element-195" data-mp="269r2hsmsnc8z">·</span>
          <span className="flex items-center gap-1" data-id="element-196" data-mp="267wlgpen84a6">
            <LockIcon className="h-3.5 w-3.5 text-accent" data-id="element-197" data-mp="2b1ra8793v9g4" />
            Pago seguro
          </span>
          <span className="text-accent/40" data-id="element-198" data-mp="2fyr6xrk2ezuk">·</span>
          <span className="flex items-center gap-1" data-id="element-199" data-mp="2g256ks1cguyb">
            <CreditCardIcon className="h-3.5 w-3.5 text-accent" data-id="element-200" data-mp="2kxkktl39ksv9" />
            Mercado Pago
          </span>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 md:mt-14 md:grid-cols-4" data-id="element-201" data-mp="2p1a5hzgtiqb0">
          {heroStats.map(([value, label]) => <div key={label} className="rounded-2xl border border-line bg-white p-4 text-center shadow-sm" data-id="element-202" data-mp="umhdeaf58hnt">
              <p className="text-2xl font-black text-primary md:text-3xl" data-id="element-203" data-mp="zmc4of2tz99e">{value}</p>
              <p className="mt-1 text-[11px] font-bold leading-tight text-slate-500 md:text-sm" data-id="element-204" data-mp="4acm5ch3dp7f">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}